<ng-container *ngIf="!errorData">
    <top-bar #topBar class="app__top-bar"></top-bar>
    <lobby class="app__content"></lobby>
    <side-menu></side-menu>
    <ng-container #rootViewContainerRef></ng-container>
    <toast></toast>
    <wallet-anim-canvas></wallet-anim-canvas>
</ng-container>
